var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React from 'react';
var ListItem = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, listRef = _a.listRef, rest = __rest(_a, ["children", "className", "listRef"]);
    return (React.createElement("li", __assign({ className: classnames('syl-toolbar-tool-horizon', (_b = {},
            _b[className] = className,
            _b)), ref: listRef }, rest),
        React.createElement("button", { className: "syl-toolbar-tool-horizon-content", type: "button" }, children)));
};
var List = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, getRef = _a.getRef, rest = __rest(_a, ["children", "className", "getRef"]);
    return (React.createElement("ol", __assign({ className: classnames('syl-toolbar-menu', (_b = {},
            _b[className] = className,
            _b)), ref: getRef }, rest), children));
};
export { List, ListItem };
//# sourceMappingURL=index.js.map